module.exports = __webpack_public_path__ + "static/media/Search.8672154a.png";